import React, { useState } from "react"
import { Box, Button } from "@material-ui/core"
import { TabletMacOutlined } from "@material-ui/icons"
import { DeviceActionCard, NoItemsMessage, DeviceCreator, SearchInput, LoadingSpinner } from "../../components"
import { useAuth } from "../../services"
import { useMutationDeleteDevice, useQueryDevices } from "../../data"
import { toId } from "../../utils"
import SettingsFooter from "../../components/Settings/SettingsFooter"

const Devices = () => {
  const {
    settings: { locations },
  } = useAuth()
  const { data, refetch, loading } = useQueryDevices()
  const [deleteDevice] = useMutationDeleteDevice()

  const [open, setOpen] = useState(false)
  const [edit, setEdit] = useState(null)
  const [searchText, setSearchText] = useState("")

  const handleFilter = (text) => {
    setSearchText(text.toLowerCase())
  }

  const handleCreateDevice = () => {
    setOpen(true)
  }
  const handleCreateDeviceClose = () => {
    setOpen(false)
    setEdit(null)
    refetch()
  }
  const handleEdit = (editDevice) => {
    setEdit(editDevice)
    setOpen(true)
  }
  const handleDelete = async (item) => {
    await deleteDevice({ variables: { id: toId(item) } })
    refetch()
  }

  if (!locations.length)
    return <NoItemsMessage>No locations are configured for your user, unable to register device</NoItemsMessage>

  const hasFilter = data?.devices.length > 1

  return (
    <>
      <DeviceCreator open={open} onClose={handleCreateDeviceClose} edit={edit} />

      {hasFilter && <SearchInput placeholder="Filter" boxProps={{ pl: 0, pr: 0 }} onChange={handleFilter} />}

      <Box mb={5} data-cy="Devices-list">
        {data?.devices
          .filter((item) => !searchText || JSON.stringify(item).toLowerCase().includes(searchText))
          .map((device) => (
            <DeviceActionCard key={device.id} device={device} onEdit={handleEdit} onDelete={handleDelete} />
          ))}

        {!data && loading && (
          <Box display="flex" justifyContent="center">
            <LoadingSpinner size={60} />
          </Box>
        )}

        {data?.devices.length === 0 && <NoItemsMessage>No devices registered</NoItemsMessage>}
      </Box>

      <SettingsFooter>
        <Button variant="contained" color="primary" onClick={handleCreateDevice} data-cy="Button-create-device">
          <TabletMacOutlined /> <Box ml={1}>Register device</Box>
        </Button>
      </SettingsFooter>
    </>
  )
}

export default Devices
